module.exports = __webpack_public_path__ + "img/BQ.bae8f921.png";